/* unplugin-vue-components disabled */import { render } from "./urls-list.vue?vue&type=template&id=5a0c5513&scoped=true"
import script from "./urls-list.vue?vue&type=script&lang=js"
export * from "./urls-list.vue?vue&type=script&lang=js"

import "./urls-list.vue?vue&type=style&index=0&id=5a0c5513&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0c5513"],['__file',"src/components/builder/urls-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a0c5513"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a0c5513', __exports__)) {
    api.reload('5a0c5513', __exports__)
  }
  
  module.hot.accept("./urls-list.vue?vue&type=template&id=5a0c5513&scoped=true", () => {
    api.rerender('5a0c5513', render)
  })

}


export default __exports__